const tracker = {
  isMenuExpanded: undefined,
  isMobile: undefined,
  isTablet: undefined,
  less1366: undefined,

  resize() {
    const isMobile = window.innerWidth < 1024;
    if (tracker.isMobile != isMobile) {
      tracker.isMobile = isMobile;
    }

    const isTablet = window.innerWidth < 1024 && window.innerWidth >= 720;
    if (tracker.isTablet != isTablet) {
      tracker.isTablet = isTablet;
    }

    const less1366 = !isMobile && window.innerWidth <= 1300;
    if (tracker.less1366 != less1366) {
      tracker.less1366 = less1366;
    }
  },
};

tracker.resize();
window.addEventListener("resize", tracker.resize);

const Plugin = {};
Plugin.install = function(Vue) {
  Vue.prototype.$layout = Vue.observable(tracker);
};

export default Plugin;
